module.exports = __webpack_public_path__ + "static/img/traning3.197d62c7.png";